
import { Component, Vue } from 'vue-property-decorator';
import Captcha from "@/components/Captcha.vue";

@Component({
  components: {
    Captcha
  }
})

export default class Login extends Vue {
  public showPassword = false;
  public formTitle = 'ورود به سامانه';
  public editedItem = {
    id: 0,
    email: '',
    password: ''
  };
  public defaultItem = {
    id: 0,
    email: '',
    password: ''
  };

  public captcha = {
    key: "",
    code: ""
  };

  onCaptchaChanged(data:any){
    this.captcha = data;
  }

  async submit() {
    const isValid = await (this.$refs.observer as any).validate();
    if (!isValid) {
      return;
    }

    // if (!this.captcha.key || !this.captcha.code) {
    //   alert("کد امنیتی را وارد کنید");
    //   return;
    // }

    this.$showLoading();
    await this.$store
      .dispatch('login', {
        email: this.editedItem.email,
        password: this.editedItem.password,
        captchaKey: this.captcha.key,
        captchaCode: this.captcha.code
      })
      .then(() => this.$router.push({ name: 'Home' }))
      .catch(async () => {
        if (this.$refs.captcha) {
          (this.$refs.captcha as any).getNewCaptcha();
        }
      });
    this.$hideLoading();
  }
}
